import React from 'react';
import styled from 'styled-components';

import { brand } from 'variables/colors';
import { fontWeightBold } from 'variables/font';
import { border } from 'variables/general';

const TabBar = styled.div`
  display: flex;
  width: calc(100% + 3em);
  margin: 0 -1.5em 3em;
  padding: 0 1.5em;
  border-bottom: ${border};
`;

const Tabs = styled.div`
  display: flex;
  width: 100%;
`;

const Tab = styled.h6`
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 1.5em;
  padding: 1em 1.2em 1.5em;
  font-weight: ${fontWeightBold};
  font-size: 0.75em;
  white-space: pre;
  cursor: pointer;

  &.active {
    &::after {
      position: absolute;
      bottom: 0;
      display: block;
      width: 100%;
      height: 4px;
      border-bottom: 4px solid ${brand};
      content: '';
    }
  }
`;

export default ({ tabs, activeTab, setActiveTab, className }) => {
  const onClick = (value) => {
    setActiveTab(value);
  };

  return (
    <TabBar className={className}>
      <Tabs>
        {tabs.map(({ label, value }) => (
          <Tab
            className={activeTab === value && 'active'}
            onClick={() => onClick(value)}
          >
            {label}
          </Tab>
        ))}
      </Tabs>
    </TabBar>
  );
};
